import { render, staticRenderFns } from "./paletteButton.vue?vue&type=template&id=7eb928c2&scoped=true"
import script from "./paletteButton.vue?vue&type=script&lang=js"
export * from "./paletteButton.vue?vue&type=script&lang=js"
import style0 from "./paletteButton.vue?vue&type=style&index=0&id=7eb928c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eb928c2",
  null
  
)

export default component.exports